import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'enable-gdpr-section',
	template: require('./enable-gdpr-section.html'),
	styles: [require('./enable-gdpr-section.scss')]
})
export class EnableGdprSectionComponent {
	@Input() gdprChecked: boolean;
	@Output() enableGdbr: EventEmitter<boolean> = new EventEmitter();

	constructor() {}

	onEnableGdpr() {
		this.gdprChecked = !this.gdprChecked;
		this.enableGdbr.emit(this.gdprChecked);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section.ts